import Modal from "@mui/material/Modal";
import {kModalStyles} from "../../../constants/styles";
import {kSystemIcons} from "../../../constants/icons";
import SystemScreenInfoHeader from "../../headers/SystemScreenInfoHeader";

export default function LevelASubthemeDescriptionDialog({open, handleClose, name, description}) {
    // Used in LevelAMetaData to display modal with
    // example zoomed picture

    // BUILD
    return(
        <Modal open={open}
               onClose={handleClose}>
            <div className={kModalStyles.screenInfoDialogStyle}>
                <SystemScreenInfoHeader handleClose={handleClose}
                                        icon={kSystemIcons.category}
                                        title={"Chapitre : " + name} />
                {/** CONTENT */}
                <div className={"w-full flex justify-start items-start p-[24px]"}>
                    <span className={"font-medium text-[14px] text-greyLight9"}>
                        {description}
                    </span>
                </div>
            </div>
        </Modal>
    )
}